"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  getSelectedCampaign: true,
  getContactGiftLink: true
};
exports.getContactGiftLink = exports.getSelectedCampaign = void 0;

var _reselect = require("reselect");

var _campaigns = require("./entities/campaigns/campaigns.selectors");

var _sendAsPerson = require("./campaign/sendAsPerson/sendAsPerson.selectors");

var _recipient = require("./recipient/recipient.selectors");

var _entities = require("./entities/entities.selectors");

Object.keys(_entities).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _entities[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _entities[key];
    }
  });
});

var getSelectedCampaign = function getSelectedCampaign(campaignId) {
  return (0, _reselect.createSelector)(_campaigns.getCampaignsMap, function (campaigns) {
    if (campaignId) {
      return campaigns[campaignId];
    }

    return undefined;
  });
};

exports.getSelectedCampaign = getSelectedCampaign;
var getContactGiftLink = (0, _reselect.createSelector)(_sendAsPerson.getGiftLink, _recipient.getLastAddedEmail, function (giftLink, lastEmail) {
  return giftLink === null || giftLink === void 0 ? void 0 : giftLink.replace('{{lead.Email Address}}', lastEmail);
});
exports.getContactGiftLink = getContactGiftLink;